export default "__VITE_PUBLIC_ASSET__4b8b1dda__"